import { initForm } from './form.js';
import { formSerializeArray, formData } from './utils.js';

export function contacts () {

    // отправка формы
    document.querySelectorAll('.js-reviewForm').forEach($form => initForm($form, {
        onSuccessCallback: function(r) {
            alert(r.message);
        }
    }));

    document.querySelectorAll('.js-citySelect').forEach($select => {
        $select.addEventListener('change', function(e) {

            // отправляем форму
            fetch('/handler/get_city', {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: formData({city_id: e.target.value}),
            })
            .then(response => response.json())
            .then(r => {
                if (r.status === 'ok') {
                    const $cityAddress     = document.querySelector('.js-cityAddress');
                    const $cityPhone       = document.querySelector('.js-cityPhone');
                    const $contactsImage   = document.querySelector('.js-contactsImage');
                    const $contactsWrapper = document.querySelector('.js-contactsWrapper');

                    if ($cityAddress) {
                        $cityAddress.textContent = r.city.address;
                    }

                    if ($cityPhone) {
                        $cityPhone.textContent = r.city.phone;
                    }

                    if ($contactsImage) {
                        $contactsImage.setAttribute('src', r.city.image || '');
                        $contactsImage.classList.toggle('is-hidden', !r.city.image);
                    }

                    if ($contactsWrapper) {
                        $contactsWrapper.classList.toggle('contacts_wrapper--no-image', !r.city.image);
                    }

                    window.myMap.setCenter([r.city.lat, r.city.lng]);
                    window.myMap.geoObjects.removeAll();
                    window.myMap.geoObjects.add(window.getPlacemark());
                }
            });

        });
    });
}
